import { useState } from "react";
import "./MyAddress.css";
import useAuth from "../../Features/Utils/useAuth";
import { userUpdate, toastError, toastSuccess } from "../../api/services";
import { useDispatch } from "react-redux";
import { setUser } from "../../Features/User/userSlice";
const UserProfile = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    fname: user?.name,
    mobile: user?.mobile,
    email: user?.email,
    gender: user?.gender,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await userUpdate(user?.id, {
        name: formData.fname,
        email: formData.email,
        gender: formData.gender,
        mobile: formData.mobile,
      });
      if (data?.data?.success) {
        dispatch(setUser(data?.data?.data));
        toastSuccess(data?.data?.message || "User updated successfully");
      } else {
        toastError(
          data?.data?.message || "User already exists with this mobile",
        );
      }
    } catch (err) {
      setLoading(false);
      console.error("Save error:", err);
      toastError(err.response?.data?.message || "Failed to save address");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="my_acc_page main__wrapper">
      <div className="my_acc_page_content content__page section-padding">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-12 col-md-12 col-xl-12">
                  <div className="step-checkout-div">
                    <div className="steps activestep">
                      <div className="icondiv">
                        <i className="fa fa-user"></i>
                      </div>
                      <h4 className="step-ttl">Account</h4>
                      <div className="before-login before-login-top">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="firstName">First Name *</label>
                              <input
                                type="text"
                                name="fname"
                                value={formData.fname}
                                onChange={handleChange}
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="mobile">Mobile</label>
                              <input
                                type="number"
                                name="mobile"
                                value={formData.mobile}
                                onChange={handleChange}
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="email">Email</label>
                              <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="form-control"
                                required
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Gender</label>
                              <select
                                name="gender"
                                value={formData.gender}
                                className="text-input"
                                onChange={handleChange}
                                style={{ padding: "12px", width: "100%" }}
                              >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <button
                              type="button"
                              form="addressForm"
                              className="btn-default theme_bg"
                              onClick={handleSubmit}
                              disabled={loading}
                            >
                              {loading ? (
                                <span className="spinner"></span>
                              ) : (
                                "Update"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="after-login">
                        <h5>Jayeshbhai | 9909999099</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
